import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const blogCategoryApi = {
  getBlogCategories: async ({ page = 1, perPage = 10, search = '', includeTrashed = false, paginate = true } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.BLOG_CATEGORIES}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false', paginate },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching blog categories:', error);
      throw error;
    }
  },

  getBlogCategoryByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.BLOG_CATEGORIES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching blog category ${identifier}:`, error);
      throw error;
    }
  },

  createBlogCategory: async (categoryData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.BLOG_CATEGORIES}`, categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating blog category:', error);
      throw error;
    }
  },

  updateBlogCategory: async (identifier, categoryData) => {
    try {
      // Send PUT request directly with the plain object
      const response = await apiClient.put(`${API_ENDPOINTS.BLOG_CATEGORIES}/${identifier}`, categoryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating blog category ${identifier}:`, error);
      throw error;
    }
  },

  trashBlogCategory: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.BLOG_CATEGORIES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing blog category ${identifier}:`, error);
      throw error;
    }
  },

  restoreBlogCategory: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.BLOG_CATEGORIES}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring blog category ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteBlogCategory: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.BLOG_CATEGORIES}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting blog category ${identifier}:`, error);
      throw error;
    }
  },
};

export default blogCategoryApi;